
import { CreateSchema, SchemaApiValue, SchemaListResponse, SchemaReadmeApiValue } from "../Models/Models";
import RespondClient from "../Models/RespondClient";
import { getApiHost } from "../util";
import { getInstance } from "./InstanceProvider";

export default class SchemaProvider {
    public dataProvider: SchemaProvider | undefined;
    public getInstance() {
        if (!this.dataProvider) {
            this.dataProvider = new SchemaProvider();
        }

        return this.dataProvider;
    }

    public getAll(offset: number, count: number, filter: string): Promise<RespondClient<SchemaListResponse>> {
        return getInstance().get(`${getApiHost()}/api/schema/all?offset=${offset}&count=${count}&filter=${filter}`);
    }

    public get(id: string): Promise<SchemaApiValue> {
        return getInstance().get(`${getApiHost()}/api/schema/${id}`);
    }

    public remove(id: string): Promise<RespondClient<boolean>> {
        return getInstance().delete(`${getApiHost()}/api/schema/${id}`);
    }

    public create(data: CreateSchema, isForce: boolean): Promise<RespondClient<SchemaApiValue>> {
        return getInstance().post(`${getApiHost()}/api/schema?forceUpdate=${isForce}`, data);
    }

    public updateReadme(id: string, content: string): Promise<RespondClient<SchemaReadmeApiValue>> {
        return getInstance().post(`${getApiHost()}/api/schema/${id}/readme`, { content });
    }

    public getReadme(id: string): Promise<RespondClient<SchemaReadmeApiValue>> {
        return getInstance().get(`${getApiHost()}/api/schema/${id}/readme`);
    }
}

export const SchemaProviderInstance = new SchemaProvider();
